<template>
  <v-container
    id="zalo_list"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm"/>
    <zalo-table :zaloContactList="zaloContactList"/>
    <!--Pagination-->
    <div class="pb-0 d-flex justify-end px-3 mt-5">
      <div class="text-right mb-1 mt-2">
        {{ showContactsIndex() }}
        <v-btn small class="pagination-btn-left" @click="currentPage--; idPaging = paging.previousId"
          :disabled="currentPage == 1">
          <v-icon>mdi-menu-left</v-icon>
        </v-btn>
        <v-btn small class="pagination-btn-right" @click="currentPage++; idPaging = paging.nextId"
          :disabled="!paging.nextId"
        >
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </div>
      <!-- <div style="width: 35px">
        <v-text-field class="pt-0" v-model="pendingPage" min="1" step="1" type="number" @input="applyPendingPage()">
        </v-text-field>
      </div> -->
    </div>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm.vue'
  import ZaloTable from './components/ZaloTable.vue'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const ZaloRepository = RepositoryFactory.get('zalo')
  export default {
    components: { FilterForm, ZaloTable },
    data () {
      return {
        filterForm: {
          keyword: '',
          status: 0
        },
        zaloContactList: [],
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        loading: true,
        paging: {},
        idPaging: null,
        backward: false,
      }
    },
    watch: {
      currentPage: {
        handler(newVal, oldVal) {
          this.backward = newVal < oldVal;
          this.getZaloContactList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getZaloContactList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      this.getZaloContactList();
      Bus.$on('zalo-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.backward = false;
        this.idPaging = null;
        this.getZaloContactList()
      })
      Bus.$on('zalo-reload', () => {
        this.getZaloContactList()
      })
    },
    beforeDestroy () {
      Bus.$off('zalo-list-filter')
    },
    methods: {
      async getZaloContactList () {
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          status: this.filterForm.status,
          backward: this.backward,
          id: this.idPaging || "",
        }

        if (this.filterForm.keyword || this.filterForm.status !== null) {
          this.loading = true
          const loader = this.$loading.show()
          const response = await ZaloRepository.list(params)

          this.paging = {
            nextId: _.get(response, 'data.paging.nextId', null),
            previousId: _.get(response, 'data.paging.previousId', null),
          };

          loader.hide()
          this.loading = false
          if (response.success) {
            this.zaloContactList = _.get(response, 'data.data', [])
            this.totalItem = response.totalItem
          }
        } else {
          this.zaloContactList = []
          this.totalItem = 0
        }
      },
      showContactsIndex() {
        if(this.zaloContactList.length > 0) {
          let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
          return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
        }else {
          return ('0 - 0')
        }
      },
    },
  }
</script>
